import * as React from 'react';
import { memo } from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import Accordion from '../../../../components/Accordion/Accordion';
import { eventTracker } from '../../../../helpers/EventTracker/EventTracker';
import { useActions } from '../../../../hooks/useActions';

const sendEventTrack = (title: string) => {
    eventTracker.track({
        category: title,
        action: 'cruisepage-infobox',
        label: title,
    });
};

const Decks = () => {
    const { title, decks } = useSelector((state: RootStateOrAny) => state.cruisePage);
    const { getDecks } = useActions();

    React.useEffect(() => {
        getDecks();
    }, []);

    if (!decks) return null;

    return (
        <Accordion
            firstTabOpenByDefault
            onHeaderClick={() => sendEventTrack(title)}
            items={decks.map((item) => ({
                title: item.title,
                content: (
                    <img
                        className="deck-plan__img"
                        loading="lazy"
                        alt={item.title}
                        src={item.deckPlan.original.url}
                    />
                ),
            }))}
        />
    );
};

export default memo(Decks);
